import { render, staticRenderFns } from "./MathLiveEditor.vue?vue&type=template&id=57d47712&scoped=true"
import script from "./MathLiveEditor.vue?vue&type=script&lang=js"
export * from "./MathLiveEditor.vue?vue&type=script&lang=js"
import style0 from "./MathLiveEditor.vue?vue&type=style&index=0&id=57d47712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d47712",
  null
  
)

export default component.exports